<template>
  <v-main>
    <router-view/>
  </v-main>
</template>

<script>
export default {
  name: 'BaseMobileLayout'
}
</script>

<style scoped>

</style>
